export default __webpack_public_path__ + "static/media/dictionary-logo1.a5b92f3c.jpg";